import { fileInput, input, label } from './adminUi';

export default function GalleryForm({
  item,
  onChange,
  onUploadImage,
  uploadHint,
  albumOptions = [],
  hideImageBlock = false,
}) {
  function set(field, value) {
    onChange({ ...item, [field]: value });
  }

  const gridClass = 'grid w-full gap-6 sm:grid-cols-2';

  return (
    <div className={gridClass}>
      {hideImageBlock ? null : (
        <div className="sm:col-span-2 rounded-xl border border-neutral-200/90 bg-neutral-50/80 p-4 sm:p-5">
          <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-neutral-500">Image</p>
          <label className={`${label} mb-0`}>
            Upload (Cloudinary)
            <input
              type="file"
              accept="image/*"
              className={fileInput}
              onChange={(e) => onUploadImage?.(e.target.files?.[0])}
            />
            {uploadHint ? (
              <span className="mt-1.5 block text-[11px] text-neutral-500">{uploadHint}</span>
            ) : (
              <span className="mt-1.5 block text-[11px] text-neutral-500">
                Upload fills the URL below automatically.
              </span>
            )}
          </label>

          {item.src ? (
            <button
              type="button"
              onClick={() => set('src', '')}
              className="mt-3 text-xs font-medium text-neutral-600 underline decoration-neutral-300 hover:text-neutral-900"
            >
              Clear image
            </button>
          ) : null}
        </div>
      )}
      <label className={`${label} sm:col-span-2`}>
        Album
        <select className={input} value={item.album ?? ''} onChange={(e) => set('album', e.target.value)} required>
          <option value="" disabled>
            Select album
          </option>
          {albumOptions.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
        <span className="mt-1.5 block text-[11px] font-normal text-neutral-500">
          Each photo must belong to an album.
        </span>
      </label>
      <label className={`${label} sm:col-span-2`}>
        Image title / purpose
        <input
          className={input}
          value={item.title ?? ''}
          onChange={(e) => set('title', e.target.value)}
          placeholder="e.g. Field inspection, harvest day, team at nursery"
        />
        <span className="mt-1.5 block text-[11px] font-normal text-neutral-500">
          Short label visitors see under the photo (optional).
        </span>
      </label>
      <label className={`${label} sm:col-span-2`}>
        Alt text (optional)
        <input className={input} value={item.alt} onChange={(e) => set('alt', e.target.value)} />
        <span className="mt-1.5 block text-[11px] font-normal text-neutral-500">
          Helps SEO and accessibility when filled.
        </span>
      </label>
    </div>
  );
}
